<template>
  <div>
    <v-menu
      bottom
      offset-y
      open-on-hover
      nudge-left="60"
    >
      <template v-slot:activator="{ on }">
        <v-icon
          class="setting-icon"
          color="metalGreyDark"
          v-on="on"
        >
          mdi-cog
        </v-icon>
      </template>
      <v-list>
        <v-list-tile
          class="menu-item"
        >
          <span @click="showDialog = true">
            表示項目編集
          </span>
        </v-list-tile>
      </v-list>
    </v-menu>
    <CompanyConfigDialog v-model="showDialog" />
  </div>
</template>
<script>
import CompanyConfigDialog from './CompanyConfigDialog'

export default {
  name: 'TableHeaderSettings',
  components: {
    CompanyConfigDialog
  },
  data () {
    return {
      showDialog: false
    }
  }
}
</script>
<style lang="scss" scoped>
.menu-item{
  cursor: pointer;
  &:hover{
    background: rgba(0, 0, 0, 0.021);
  }
}
.setting-icon{
  cursor: pointer;
}
</style>
